export const Categories = {
    AUTHENTICATION: 'Authentication',
    VISIT: 'Visit',
    AUTH_VISIT: 'Authenticated visit',
};
